module App.State

open Elmish
open Elmish.Navigation
open Elmish.UrlParser
open Browser
open Global
open Types

let pageParser: Parser<Page->Page,Page> =
    oneOf [
        map Page.Applications (s "apps")
        map Page.ApplicationsWithParameters (s "apps" </> str)
        map Home (s "home")
        map Page.Plugin (s "plugin" </> str)
    ]

let private initPage page model =
    match page with
    | Page.Applications ->
        match model.Applications with
        | None ->
            let (m, c) = Applications.init()
            { model with Applications = Some m }, (Cmd.map App.Types.Msg.Applications c)
        | Some _ ->
            model, Cmd.Empty
    | Page.ApplicationsWithParameters _ ->
        match model.Applications with
        | None ->
            let (m, c) = Applications.init()
            { model with Applications = Some m }, (Cmd.map App.Types.Msg.Applications c)
        | Some _ ->
            model, Cmd.Empty
    | _ -> model, Cmd.Empty

let urlUpdate (result : Page option) model =
    match result with
    | None ->
        console.error("Error parsing url")
        model, Navigation.modifyUrl (toHash model.CurrentPage)
    | Some page ->
        let (m, c) = initPage page model
        { m with CurrentPage = page }, c

let init result =
    let (model, cmd) =
        urlUpdate result
          { CurrentPage = Home
            Applications = None
            PluginPages = None
            IamEditorUrl = None}

    let cmd2 =
        Cmd.OfPromise.either
            (Service.getPages)
            ()
            (fun i -> i |> Msg.PluginsLoaded)
            (fun _ -> { pages = [] } |> Msg.PluginsLoaded)

    let cmd3 =
        Cmd.OfPromise.perform
            (fun () -> Service.iamEditorUrl)
            ()
            (fun i -> i |> Msg.IamUrlLoaded)

    model, Cmd.batch [ cmd; cmd2; cmd3 ]

let update msg model =
    match msg with
    | Applications m ->
        match model.Applications with
        | Some a ->
            let (m,c) = Applications.update m a
            { model with Applications = (Some m)}, (Cmd.map Applications c)
    | PluginsLoaded pages -> { model with PluginPages = Some pages }, Cmd.Empty
    | Msg.IamUrlLoaded url -> { model with IamEditorUrl = url}, Cmd.Empty
